module.exports = __webpack_public_path__ + "static/media/rechargenow.358541de.jpg";